export type ExtraligaDivision = "All";

export interface ExtraligaTeam {
  id: string;
  name: string;
  nameCs: string;
  abbr: string;
  city: string;
  logo: string;
  division: ExtraligaDivision;
}

// Czech Extraliga team logos from TheSportsDB
const EXTRALIGA_LOGOS: Record<string, string> = {
  "1": "https://r2.thesportsdb.com/images/media/team/badge/1rlgyo1656779235.png",   // Sparta Praha
  "2": "https://r2.thesportsdb.com/images/media/team/badge/s48n6j1656779279.png",   // Oceláři Třinec
  "3": "https://r2.thesportsdb.com/images/media/team/badge/rvnxf11656779192.png",   // Škoda Plzeň
  "4": "https://r2.thesportsdb.com/images/media/team/badge/rkv2u01656779181.png",   // Dynamo Pardubice
  "5": "https://r2.thesportsdb.com/images/media/team/badge/eqlnrn1656779065.png",   // Kometa Brno
  "6": "https://r2.thesportsdb.com/images/media/team/badge/q2f4e81656779103.png",   // Mountfield HK
  "7": "https://r2.thesportsdb.com/images/media/team/badge/rqk3lq1656779299.png",   // Vítkovice Ridera
  "8": "https://r2.thesportsdb.com/images/media/team/badge/5t1i2b1656779085.png",   // Mladá Boleslav
  "9": "https://r2.thesportsdb.com/images/media/team/badge/e1n2bt1656779115.png",   // Motor České Budějovice
  "10": "https://r2.thesportsdb.com/images/media/team/badge/j5tbav1656779055.png",  // Energie Karlovy Vary
  "11": "https://r2.thesportsdb.com/images/media/team/badge/j1z86i1656779148.png",  // HC Olomouc
  "12": "https://r2.thesportsdb.com/images/media/team/badge/oayqx41656779074.png",  // Rytíři Kladno
  "13": "https://r2.thesportsdb.com/images/media/team/badge/ipwiqf1656779078.png",  // Verva Litvínov
  "14": "https://r2.thesportsdb.com/images/media/team/badge/1bfz231656779310.png",  // Berani Zlín
};

const getExtraligaLogo = (teamId: string) => EXTRALIGA_LOGOS[teamId] ?? "";

export const EXTRALIGA_TEAMS: ExtraligaTeam[] = [
  { id: "1", name: "HC Sparta Praha", nameCs: "HC Sparta Praha", abbr: "SPA", city: "Prague", logo: getExtraligaLogo("1"), division: "All" },
  { id: "2", name: "HC Oceláři Třinec", nameCs: "HC Oceláři Třinec", abbr: "TRI", city: "Třinec", logo: getExtraligaLogo("2"), division: "All" },
  { id: "3", name: "HC Škoda Plzeň", nameCs: "HC Škoda Plzeň", abbr: "PLZ", city: "Plzeň", logo: getExtraligaLogo("3"), division: "All" },
  { id: "4", name: "HC Dynamo Pardubice", nameCs: "HC Dynamo Pardubice", abbr: "PAR", city: "Pardubice", logo: getExtraligaLogo("4"), division: "All" },
  { id: "5", name: "HC Kometa Brno", nameCs: "HC Kometa Brno", abbr: "KOM", city: "Brno", logo: getExtraligaLogo("5"), division: "All" },
  { id: "6", name: "Mountfield HK", nameCs: "Mountfield HK", abbr: "MHK", city: "Hradec Králové", logo: getExtraligaLogo("6"), division: "All" },
  { id: "7", name: "HC Vítkovice Ridera", nameCs: "HC Vítkovice Ridera", abbr: "VIT", city: "Ostrava", logo: getExtraligaLogo("7"), division: "All" },
  { id: "8", name: "BK Mladá Boleslav", nameCs: "BK Mladá Boleslav", abbr: "MBL", city: "Mladá Boleslav", logo: getExtraligaLogo("8"), division: "All" },
  { id: "9", name: "HC Motor České Budějovice", nameCs: "HC Motor České Budějovice", abbr: "MOT", city: "České Budějovice", logo: getExtraligaLogo("9"), division: "All" },
  { id: "10", name: "HC Energie Karlovy Vary", nameCs: "HC Energie Karlovy Vary", abbr: "KVA", city: "Karlovy Vary", logo: getExtraligaLogo("10"), division: "All" },
  { id: "11", name: "HC Olomouc", nameCs: "HC Olomouc", abbr: "OLO", city: "Olomouc", logo: getExtraligaLogo("11"), division: "All" },
  { id: "12", name: "Rytíři Kladno", nameCs: "Rytíři Kladno", abbr: "KLA", city: "Kladno", logo: getExtraligaLogo("12"), division: "All" },
  { id: "13", name: "HC Verva Litvínov", nameCs: "HC Verva Litvínov", abbr: "LIT", city: "Litvínov", logo: getExtraligaLogo("13"), division: "All" },
  { id: "14", name: "PSG Berani Zlín", nameCs: "PSG Berani Zlín", abbr: "ZLI", city: "Zlín", logo: getExtraligaLogo("14"), division: "All" },
];

export const EXTRALIGA_DIVISIONS: ExtraligaDivision[] = ["All"];

export const getExtraligaTeamByAbbr = (abbr: string): ExtraligaTeam | undefined => {
  return EXTRALIGA_TEAMS.find((team) => team.abbr === abbr);
};
